import { Typography } from '@mui/material';
import InlineLinkButton from 'ui-component/shared/InlineLinkButton';

export function renderUrl(text: string, link: string) {
  if (text) {
    return (
      <Typography>
        {text}
        <InlineLinkButton tooltip="View Link" link={link} />
      </Typography>
    );
  }
  return '-';
}
